import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Logo from "../../assets/img/custom/logo.png";
import { Label, Input, Button, Form, Spinner } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { login } from "store/actions/authActions";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let dispatch = useDispatch();
  let auth = useSelector((state) => state.auth);
  if (auth.uid) return <Redirect to="/admin/index" />;
  return (
    <>
      <div className="text-center mt-4 mt-lg-5">
        <Link to="https://fans-help-players-athlete.web.app/">
          <img src={Logo} alt="logo" className="logo" />
        </Link>
      </div>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          let creds = {
            email: email,
            password: password,
          };
          dispatch(login(creds));
        }}
      >
        <div className="auth-card">
          <h2 className="auth-heading">Admin Login</h2>

          <Label className="mt-3 auth-label">
            <b>Email</b>
          </Label>
          <Input
            placeholder="name@gmail.com"
            required
            value={email}
            type="email"
            className=" custom-input"
            onChange={(e) => setEmail(e.target.value)}
          />

          <Label className="mt-3 auth-label">
            <b>Password</b>
          </Label>
          <Input
            required
            value={password}
            type="password"
            placeholder="Your Password"
            className=" custom-input"
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center mt-3">
            <div className="pb-0 d-flex align-items-center mb-2 mb-sm-0">
              <Input
                type="checkbox"
                className="mx-1"
                style={{ marginTop: "0.1rem" }}
              />
              <Label className="ml-4 mr-1 auth-label my-0">Remember me</Label>
            </div>
            <Link to="/auth/forget-password" className="ml-sm-auto">
              <Label className="auth-label cursor-pointer text-center text-sm-right">
                <u>Forgot Password?</u>
              </Label>
            </Link>
          </div>
        </div>
        <div className="text-center">
          <Button
            disabled={!email || !password}
            className="auth-button mt-4 mt-lg-5"
            type="submit"
          >
            {auth.loading ? <Spinner size="md" /> : "Login"}
          </Button>
        </div>
      </Form>
    </>
  );
}

export default Login;
